var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9239 6.11652L19.8909 15.3358C19.6945 16.2263 19.311 17.0349 18.7812 17.7207L6.27888 5.21915C6.96476 4.68913 7.77346 4.30553 8.66423 4.1091L17.8835 2.07608C20.2314 1.55832 22.4417 3.76864 21.9239 6.11652Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21834 6.27991L17.7205 18.7813C17.0348 19.3111 16.2263 19.6945 15.3358 19.8909L6.11653 21.9239C3.76864 22.4417 1.55832 20.2314 2.07608 17.8835L4.1091 8.66421C4.30543 7.77389 4.68874 6.96556 5.21834 6.27991Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerAlt);
export default __webpack_public_path__ + "static/media/pointer-alt.da755508e1d83f9f92ef722665424895.svg";
export { ForwardRef as ReactComponent };